import { Button } from "@/components/ui/button";
import SearchInput from "@/components/ui/searchInput";
import { setIsAddQualification } from "@/module/education/stores/educationSlice";
import { useAppDispatch } from "@/stores/hook";

export default function QualificationHeader() {
  const dispatch = useAppDispatch();

  const handleAddQualification = () => {
    dispatch(setIsAddQualification(true));
  };

  return (
    <div className="w-full flex items-center justify-between gap-4">
      <SearchInput
        placeholder="Find a qualification…"
        isKbd={false}
        className="flex-1"
      />
      <Button variant="primary" onClick={handleAddQualification}>
        + Add Qualification
      </Button>
    </div>
  );
}
